module.exports = "/_next/static/images/circuit-edbe3d0ce9eb85221046e6e3e4ffd31c.png";